// @flow
import React, { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import GridTile, {
	type OwnProps as GridTileProps,
} from "root/components/ResultImageGrid/GridTile";
import GridTilePreviewInfo from "../GridTilePreviewInfo";
import actions, { types as ats } from "../../actions";
import { StyledGridItemWrapper } from "~/src/root/components/StyledGridItemWrapper/StyledGridItemWrapper";

const { [ats.SET_FILE_SELECTION]: setFileSelection } = actions.creators;

const FileItem = (props: GridTileProps) => {
	const dispatch = useDispatch();

	const onSelection = useCallback((id, e) => {
		dispatch(setFileSelection({
			id,
			e,
			multiple: props.isMultiple,
		}));
	}, [dispatch, props.isMultiple]);

	return (
		<StyledGridItemWrapper>
			<GridTile
				info={props}
				isLoading={props.isLoading}
				tileNsSize="100"
				isSelected={props.isSelected}
				allowSelect
				alwaysShowPreviewInfo
				customPreviewInfo={GridTilePreviewInfo}
				selectionAction={onSelection}
				isMultiple={props.isMultiple}
			/>
		</StyledGridItemWrapper>
	);
};

export default memo<GridTileProps>(FileItem);
